/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2017, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../../lib/@waca/core-client/js/core-client/ui/core/View',
	'text!./templates/filterDockItem.html',
	'../utils/FilterMenu',
	'../controls/FilterErrorView',
	'../../widgets/livewidget/nls/StringResources',
	'../../lib/@waca/core-client/js/core-client/utils/ClassFactory',
	'jquery',
	'underscore'
], function(BaseView, FilterDockItemTemplate, FilterMenu, FilterErrorView, StringResources, AMD, $, _) {



	var FilterDockItemView = BaseView.extend([], {
		templateString: FilterDockItemTemplate,

		className: 'filterItemWrapper',

		events: {
			'touchend span:not(.modelFilter_pageContext).wa-filterDock-filterName': 'openDropdownFilterViewAction',
			'primaryaction span:not(.modelFilter_pageContext).wa-filterDock-filterName': 'openDropdownFilterViewAction',

			'touchend .filter-menu-position': 'toggleDropdownMenu',
			'primaryaction .filter-menu-position': 'toggleDropdownMenu',

			'escapeaction .wa-filterDock-filterName, .wa-filterDock-filterItemMount': 'handleFilterViewEscapeAction',
			'escapeaction .filter-menu-position, .filter-menu': 'handleDropdownMenuEscapeAction'
		},

		_AMD: AMD,

		/**
		 * Constructor
		 *
		 * @param {object} args - arguments
		 *
		 * @constructs FilterDockItemView
		 * @extends {lib/@waca/core-client/js/core-client/ui/core/View}
		 */
		init: function(params) {
			FilterDockItemView.inherited('init', this, arguments);
			this.onOpenDropdownFilterView = params.onOpenDropdownFilterView;
			this.toggleCardHighlighting = params.toggleCardHighlighting;

			var menuConfig = {
				menuActionHandler: params.menuActionHandler,
				onMenuShowHandler: this._onMenuShow.bind(this),
				onMenuHideHandler: this._onMenuHide.bind(this),
				iconsFeature: params.iconsFeature
			};
			this.menu = new FilterMenu(menuConfig);
			let missingDataName = StringResources.get('missingColumn', { 'columnLabel': params.viewModel.name });
			this.vm = _.extend(_.clone(params.viewModel), {
				hideItemMenuIcon: true,
				filterDockItemNameAriaLabel: StringResources.get('filterDockItemNameAriaLabel'),
				missingData: params.missingData,
				missingDataName: missingDataName
			});
			this.render(this.vm)
				.then(this.menu.render.bind(this.menu, { viewModel: this.vm, mountNode: this.getFilterMenuMountNode() }));
			if (!params.isAuthoringMode) {
				this.hideItemMenu();
			}

		},

		/**
		 * Render view
		 * @param {Object} viewModel - view model containing data to render in the views.
 		 * @see MemberFilterModel#getViewModel for description of object
		 *
		 * @return {Promise} promise to be resolved when rendering is done
		 */
		render: function(viewModel) {
			this.$el.empty();
			this.$el
				.attr('data-dockkey', _.escape(viewModel.dockKey))
				.html(this.dotTemplate(viewModel));
			this._updateError(viewModel.error);
			return Promise.resolve();
		},

		updateMenuState: function(viewModel) {
			return this.menu.updateMenuItems(viewModel.menuItems);
		},

		/**
		* The following method opens the drop down filter view.
		*/
		initializeMountNodeForDropDownFilterView: function(className) {
			if(!this.isFilterViewOpen()){

				if (className && !!className.length) {
					this.getWidgetMountNode().addClass(className);
				}

				this.$('.filter-menu-position').attr('tabindex', '-1');

				this.$filterOutClickCatcher = $('<div>').attr('id', 'filterOutClickCatcher');
				$('body').append(this.$filterOutClickCatcher);

				this.$filterOutClickCatcher.on('dragstart', function(event) {
					event.stopPropagation();
					event.preventDefault();
					return false;
				});

				this.$filterOutClickCatcher.on('click touchend', function(ev){
					ev.preventDefault();
					ev.stopPropagation();
					this.getWidgetMountNode().toggle(false);
					this.toggleCardHighlightHelper(false);
					this.$filterOutClickCatcher && this.$filterOutClickCatcher.off && this.$filterOutClickCatcher.off('click dragstart');
					this.$filterOutClickCatcher && this.$filterOutClickCatcher.remove && this.$filterOutClickCatcher.remove();
					this.$filterOutClickCatcher = null;
					this.$('.filter-menu-position').attr('tabindex', '0');
				}.bind(this));

			}

			this.getWidgetMountNode().toggle(true);
			this.setMountNodeOffSet();

		},

		/**
		*
		* Handler to open the filter view such a memeber picker view
		*
		*/
		openDropdownFilterViewAction: function(event) {
			event.preventDefault();
			if(this.onOpenDropdownFilterView){
				this.onOpenDropdownFilterView();
				this.toggleCardHighlightHelper(true);
			}
		},

		/**
		* Toggle filter menu
		*
		* @param {Jquery event} Event
		*/
		toggleDropdownMenu: function(event){
			event.stopPropagation();
			event.preventDefault();

			var filterMenuOffSetPosition = this.$('.filter-menu-position').offset();
			var $filterMenu = this.$('.filter-menu');
			$filterMenu.offset(filterMenuOffSetPosition);
			this.menu.toggle();
		},

		/**
		*@return A node filter views can mount on within this view.
		*/
		getWidgetMountNode: function() {
			this.$widgetMountNode = this.$widgetMountNode ? this.$widgetMountNode : this.$('.wa-filterDock-filterItemMount');
			return this.$widgetMountNode;
		},

		renderInFilterItemView: function(viewModel){
			if(viewModel && viewModel.viewClass){
				this.getWidgetMountNode()
					.addClass(viewModel.viewClass);
			}

			return Promise.resolve({ mountNode: this.getWidgetMountNode() });
		},

		/**
		 * Render error view
		 *
		 * @return {Promise} Resolves when rendering error operation is complete
		 */
		renderError: function (error) {

			this.errorView = new FilterErrorView({
				commonView: this
			});
			return this.errorView.renderViewComposition(error);
		},

		processError: function(error) {
			return this.renderError(error);
		},

		getFilterMenuMountNode: function () {
			this.$filterMenuMountNode = this.$filterMenuMountNode  ? this.$filterMenuMountNode :  this.$('.filter-menu');
			return this.$filterMenuMountNode;
		},

		/**
		* The following method will determine the left offset of the mount node.
		* @param offSetPosition - current offset position to use on the mount node
		*/
		_setMountNodeLeftOffset: function(offSetPosition) {
			/* We don't want the filter dialog to go outside the filter dock container
			 * because then it will be partially hidden. To make sure the entire
			 * dialog is visible:
			 * - Try to align the left edge of the filter dialog with the left
			 *   edge of the filter item
			 * - If the dialog's rightmost edge would go past the filter dock container,
			 *   we instead align the right edge of the filter dialog with the right
			 *   edge of the filter item.
			 * Note, there could be issues if the filter dock is shrunk to less than the
			 * width of the dialog. This is an extreme case that we won't account for
			 * right now.
			 */

			var $filterItemMount = this.getWidgetMountNode();
			var filterItemMountWidth = $filterItemMount.width();
			var $filterDock = $('.filterDockContainer');
			var filterDockFarthestVisiblePoint = $filterDock.width() + $filterDock.offset().left;

			if(offSetPosition.left + filterItemMountWidth > filterDockFarthestVisiblePoint) {
				offSetPosition.left -= (filterItemMountWidth - this.$('.wa-filterDock-filterItem-bottom').width());
			}
		},

		/**
		* Set the position of the filter menu.
		*
		*/
		setMountNodeOffSet: function(){
			var bottomOffSetPosition = this.$('.wa-filterDock-filterItem-bottom').offset();

			// Historic note: we used to have 5px margin, but in new design the arrow is removed so we don't want the margin.

			// Ensure the left offset point is appropriately set.
			this._setMountNodeLeftOffset(bottomOffSetPosition);

			this.$('.wa-filterDock-filterItemMount').offset(bottomOffSetPosition);
		},

		adjustMountNodeHeight: function(minHeight, height) {
			var mountNodeOffset = this.$('.wa-filterDock-filterItemMount').offset();
			var appHeight = $('#main').height();
			var availableHeight = appHeight - mountNodeOffset.top;
			var finialHeight;

			if ( availableHeight < height && availableHeight > minHeight ) {
				finialHeight = availableHeight + 'px';
			} else if (availableHeight >= height) {
				finialHeight = '';
			} else {
				finialHeight = minHeight + 'px';
			}
			this.$('.wa-filterDock-filterItemMount').css('height', finialHeight);
		},

		_updateFilterName: function(viewModel) {
			var title = this.$el.find('.wa-filterDock-filterName');
			var oldName = title.text();
			var newName = viewModel.name;
			if (this.vm.missingData) {
				let missingDataName = StringResources.get('missingColumn', { 'columnLabel': newName });
				title.attr('title', missingDataName);
				title.text(missingDataName);
			}else if (oldName !== newName) {
				title.attr('title', newName);
				title.text(newName);
			}

		},

		_updateError: function(error) {
			this.$el.find('.wa-filterDock-error').toggleClass('wa-hide', !error);
		},

		/**
		* Update an existing filter item entry
		* @param {Object} viewModel - view model containing data to render in the views.
		* Note, thsi viewModel is only contains information needed for an update, it
		* is not a complete (as of yet) model as the one used to initialize this item.
		*/
		update: function(viewModel) {
			this._updateFilterName(viewModel);
			this._updateError(viewModel.error);
			this.onSelectStatUpdate(viewModel.selectedCount, null, viewModel.text, viewModel.isModeledFilter);
			this.updateMenuState(viewModel);
		},
		/**
		* update the view with th comma separated values of selections/Range
		* @param {int} selected The number of selected filter items
		* @param {int} totalMembers unused
		* @param {String} selectedStr The current filtered items for display
		* @param {boolean} isModeledFilter if true, this filter dock item is from a modeled filter
		*/
		onSelectStatUpdate: function(selected, totalMembers, selectedStr, isModeledFilter) {

			if(!isModeledFilter && (selected === 0 || !selectedStr)) {
				this.$('.wa-filterDock-filterItem-bottom').css('visibility', 'hidden');
			} else {
				this.$('.wa-filterDock-filterItem-bottom').css('visibility', 'visible');
			}

			this.$('.wa-filterDock-filterSelectCount').prop('innerHTML', selected);
			this.$('.wa-filterDock-filterItemText').prop('innerHTML', _.escape(selectedStr));
			this.$('.wa-filterDock-filterItemText').prop('title', selectedStr);
		},

		/**
		* clean up the blocker when child filter instance is closed
		*
		*/
		onViewClose: function(){
			if (this.$filterOutClickCatcher) {
				this.$filterOutClickCatcher.click();
			}
		},

		/**
		* @return True if filter item view is loaded
		*/
		isFilterViewLoaded: function(){
			return this.getWidgetMountNode().find('.commonFilterControlContainer, .filterError').length > 0;
		},

		isFilterViewOpen: function() {
			return this.getWidgetMountNode().is(':visible');
		},

		isAnyFilterViewOpen: function() {
			return $('.wa-filterDock-filterItemMount').is(':visible');
		},

		isSideMenuOpen: function() {
			return this.menu.$el.hasClass('open');
		},

		hideFilterItemView: function (){
			this.getWidgetMountNode().toggle(false);
		},

		/**
		* On menu show, enable pointer events
		*/
		_onMenuShow: function(){
			this.$filterMenuMountNode.removeClass('wa-no-pointer-event');
			this.toggleCardHighlightHelper(true);
		},

		/**
		* On menu hide, disable pointer events
		*/
		_onMenuHide: function(){
			this.$filterMenuMountNode.addClass('wa-no-pointer-event');
			this.toggleCardHighlightHelper(false);
		},

		setWidgetMountNodeHeight: function(height){
			this.getWidgetMountNode().css('height', height);
		},

		remove: function(){
			this.onOpenDropdownFilterView = null;
			this.toggleCardHighlighting = null;
			this.menu.remove();
			if(this.$widgetMountNode){
				this.$widgetMountNode.remove();
				this.$widgetMountNode = null;
			}
			FilterDockItemView.inherited('remove', this);

		},

		toggleCardHighlightHelper: function(display) {
			if(this.toggleCardHighlighting) {
				this.toggleCardHighlighting(display);
			}
		},

		/**
		 * Toggle warning icon
		 *
		 * @param {string} msg - error/warning message to display on the icon
		 * @param {boolean} state - TRUE to display and FALSE to hide
		 */
		toggleWarningIcon: function(msg, state) {
			var $el = this.$el.find('.wa-filterDock-error');

			$el.toggleClass('wa-hide', !state);

			if (msg) {
				$el.attr('title', msg);
			}
		},

		/**
		* Attach handlers to handle displaying tooltip
		*/
		_attachToolTipHandlers: function() {
			var selector = '.wa-filterDock-filterItemText';
			this.$textview = this.$el.find('.wa-filterDock-filterItem-bottom');

			if ($.fn.supportTouch) {
				var data = {
					type: 'press',
					options: {
						time: 500
					},
					handlers: [{
						name: 'pressup',
						handler: this._onHideTooltip.bind(this)
					}]
				};
				this.$textview.on('press', selector, data, this._onDisplayTooltip.bind(this));
			} else {
				this.$textview.on('mouseenter', selector, this._onDisplayTooltip.bind(this))
					.on('mouseleave', selector, this._onHideTooltip.bind(this));
			}
		},

		/**
		* Handle the events 'mouseenter' | 'press' to display the tooltip
		*
		* @param {object} event - the JQuery event object
		*/
		_onDisplayTooltip: function(event) {
			var el = event.currentTarget;
			this.$tooltip = $(el).parent();
			this.$tooltip.tooltip({ title: $(el).text(), placement: 'bottom', container: '.pageView' });
			this.$tooltip.tooltip('show');
			this.$('.wa-filterDock-filterItem-bottom').removeAttr('title'); // remove native tooltip
			this.$('.wa-filterDock-filterItemText').removeAttr('title');
			event.stopPropagation();
		},

		/**
		* Handle the 'mouseleave' | 'pressup' events to hide the tooltip
		*
		* @param {object} event - the event object
		*/
		_onHideTooltip: function(event) {
			// Destroy lingering tooltips
			this._destroyTooltip();
			if (event.stopPropagation) {
				event.stopPropagation();
			}
		},

		/**
		* Destroy the tooltip
		*/
		_destroyTooltip: function() {
			if (this.$tooltip) {
				this.$tooltip.tooltip('destroy');
				this.$tooltip = null;
			}
		},

		handleFilterViewEscapeAction: function() {
			if(this.$filterOutClickCatcher) {
				this.$filterOutClickCatcher.trigger('click');
			}
			this.$('.wa-filterDock-filterName').focus();
		},

		handleDropdownMenuEscapeAction: function() {
			if(this.menu.isOpen()) {
				this.menu.toggle();
			}
			this.$('.filter-menu-position').focus();
		},

		// Show "..." menu next to the filter in filter dock.
		showItemMenu: function() {
			this.$('.filter-menu-position').removeClass('hide');
		},

		// Hide "..." menu next to the filter in filter dock.
		hideItemMenu: function() {
			this.$('.filter-menu-position').addClass('hide');
		}
	});

	return FilterDockItemView;
});
